import _ from 'lodash'
import {
  FETCH_LOGS,
  DELETE_LOG
} from 'constants/actionTypes'

const INIT_STATE = {
  data: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_LOGS:
      let response = action.payload.data
      let pagination = action.payload.pagination
      return {
        ...state,
        data: response,
        pagination
      }
    case DELETE_LOG:
      return { ...state, data: _.reject(state.data, { id: action.payload }) }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/logs.js